<!--<span  (click)="showOrgs();op.toggle($event);">{{_org.title}}</span>-->
@if (hasLogo) {
  <span class="hidden-xs">{{ _org.title }}</span>
}
<span class="visible-xs">{{ _org.shortTitle }}</span>
